import type {
	ItemFollowIdsResponseDto,
	ItemFollowStateResponseDto,
} from '@supply-mover-2-0/shared';
import { ApiService } from './ApiService';

/**
 * Frontend service for item follows (PD-14306): a staff member follows an
 * item to be alerted when it is back in stock. Every call acts on the
 * signed-in user's own follows.
 *
 * The calls throw on failure rather than returning an error object, so the
 * store that owns the follow state can put an optimistic change back.
 */
export class ItemFollowQueryService {
	/** Ids of the items the signed-in user follows. */
	public static async getMyFollowedItemIds(): Promise<Array<number>> {
		const response =
			await ApiService.apiGet<ItemFollowIdsResponseDto>('/item-follows/me');

		return response.itemIds;
	}

	public static async follow(
		itemId: number,
	): Promise<ItemFollowStateResponseDto> {
		return ApiService.apiPut<ItemFollowStateResponseDto>(
			`/item-follows/${itemId}`,
			{},
		);
	}

	public static async unfollow(
		itemId: number,
	): Promise<ItemFollowStateResponseDto> {
		return ApiService.apiDelete<ItemFollowStateResponseDto>(
			`/item-follows/${itemId}`,
		);
	}
}
